module.exports = __webpack_public_path__ + "img/benjamin-voros-unsplash-mountain-stars_sized.08b17330.jpeg";